module.exports = __webpack_public_path__ + "static/media/EPS-BNB.9eb58f43.svg";